import { SwiperScreenSizes } from '@interfaces';

// Marks the element inside a slide that the `horizontalNavigation` arrows are
// centred on vertically. Put it on the media, not on the whole card.
export const NAVIGATION_ALIGN_ATTRIBUTE = 'data-swiper-navigation-align';

// Carries the measured height of that element into the arrows' styles.
export const NAVIGATION_ALIGN_HEIGHT_PROPERTY = '--swiper-nav-align-height';

export const BREAKPOINTS = {
  [SwiperScreenSizes.Mobile1]: {
    slidesPerView: 2,
    spaceBetween: 10,
  },
  [SwiperScreenSizes.Mobile3]: {
    slidesPerView: 3,
    spaceBetween: 10,
  },
  [SwiperScreenSizes.Tablet]: {
    slidesPerView: 3,
    spaceBetween: 10,
  },
  [SwiperScreenSizes.TabletHorizontal]: {
    slidesPerView: 4,
    spaceBetween: 16,
  },
};
